var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnUnlockHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39978 11.4004H17.6C18.6998 11.4004 19.5002 12.228 19.5004 13.1396V21.0596C19.5004 21.9714 18.6999 22.7998 17.6 22.7998H6.39978C5.29991 22.7997 4.50037 21.9713 4.50037 21.0596V13.1396C4.50057 12.228 5.30006 11.4005 6.39978 11.4004Z",
    stroke: "#4B68CF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.55,
    y: 15.7498,
    width: 0.9,
    height: 3.9,
    fill: "#172664",
    stroke: "#4B68CF",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 11.1V6.9C16.2 3.91766 13.7824 1.5 10.8 1.5H10.2C7.54906 1.5 5.40002 3.64903 5.40002 6.3V6.3",
    stroke: "#4B68CF",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnUnlockHover);
export default __webpack_public_path__ + "static/media/btn_Unlock_hover.9ba65299040362766febcd4eff3523cd.svg";
export { ForwardRef as ReactComponent };